(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["persimmon-reference"]) return;
  try {
    
(function(){
function updateBundle(root){
  if(!root)return;
  const chosen=root.querySelector('.sr-bundle input:checked');
  if(!chosen)return;
  const currentPrice=root.querySelector('[data-current-price]');
  if(currentPrice)currentPrice.textContent=chosen.dataset.price;
  const tier=Number(chosen.dataset.bundleIndex||1);
  const includedGifts=['Snorva Bamboo Soap Dish','Snorva Exfoliating Soap Pouch','Snorva Travel Tin'].slice(0,tier);
  const property=root.querySelector('[data-sr-gift-property]');
  if(property)property.value=includedGifts.join(', ');
  root.querySelectorAll('[data-gift-required]').forEach(function(gift){
    const req=Number(gift.dataset.giftRequired);
    const included=req<=tier;
    gift.classList.toggle('sr-gift--locked',!included);
    const status=gift.querySelector('[data-gift-status]');
    if(status)status.textContent=included?'Included with this bundle':'Unlock with '+(req===2?'4':'8')+' bars';
  });
}
function updateCountdown(root){
  if(!root)return;
  const now=new Date();
  const midnight=new Date(now);
  midnight.setHours(24,0,0,0);
  const secs=Math.max(0,Math.ceil((midnight-now)/1000));
  const pad=function(x){return String(x).padStart(2,'0');};
  root.querySelector('[data-sr-hours]').textContent=pad(Math.floor(secs/3600));
  root.querySelector('[data-sr-minutes]').textContent=pad(Math.floor(secs%3600/60));
  root.querySelector('[data-sr-seconds]').textContent=pad(secs%60);
}
document.querySelectorAll('.sr-page').forEach(function(root){updateBundle(root);updateCountdown(root.querySelector('[data-sr-countdown]'));});
document.addEventListener('change',function(event){if(event.target.matches('.sr-bundle input'))updateBundle(event.target.closest('.sr-page'));});
document.addEventListener('submit',async function(event){
  const form=event.target;
  if(!form.matches('.sr-page .sr-product-form'))return;
  event.preventDefault();
  const button=form.querySelector('button[type="submit"]');
  if(button.disabled)return;
  button.disabled=true;
  try{
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form),credentials:'same-origin'});
    if(!response.ok){
      const details=await response.json().catch(function(){return {};});
      throw new Error(details.description||'Unable to add your selected bundle');
    }
    window.location.assign('/checkout');
  }catch(error){
    button.disabled=false;
    window.alert(error.message||'Unable to proceed to checkout. Please try again.');
  }
},true);
setInterval(function(){document.querySelectorAll('.sr-page [data-sr-countdown]').forEach(updateCountdown);},1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snorva-leaf-fidelity"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.snl-root').forEach(function(root){
  const slides=Array.from(root.querySelectorAll('[data-snl-slide]'));
  const thumbs=Array.from(root.querySelectorAll('[data-snl-thumb]'));
  let index=0;
  function show(next){
    if(!slides.length)return;
    index=(next+slides.length)%slides.length;
    slides.forEach(function(slide,i){slide.hidden=i!==index});
    thumbs.forEach(function(thumb,i){thumb.classList.toggle('is-selected',i===index);thumb.setAttribute('aria-pressed',i===index?'true':'false')});
  }
  thumbs.forEach(function(thumb){thumb.addEventListener('click',function(){show(Number(thumb.getAttribute('data-snl-thumb'))||0)})});
  const prev=root.querySelector('[data-snl-prev]');
  const next=root.querySelector('[data-snl-next]');
  if(prev)prev.addEventListener('click',function(){show(index-1)});
  if(next)next.addEventListener('click',function(){show(index+1)});
  const bundles=Array.from(root.querySelectorAll('[data-snl-bundle]'));
  const total=root.querySelector('[data-snl-total]');
  const stickyPrice=root.querySelector('[data-snl-sticky-price]');
  bundles.forEach(function(bundle){
    const input=bundle.querySelector('input[type=radio]');
    if(!input)return;
    input.addEventListener('change',function(){
      bundles.forEach(function(item){item.classList.toggle('is-selected',item===bundle)});
      if(total)total.textContent=input.dataset.snlMoney;
      if(stickyPrice)stickyPrice.textContent=input.dataset.snlMoney;
    });
  });
  const scroll=root.querySelector('[data-snl-scroll]');
  if(scroll)scroll.addEventListener('click',function(){root.querySelector('.snl-offers-head').scrollIntoView({behavior:'smooth',block:'center'})});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snorva-leaf-reference"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.snl-root').forEach(function(root){
  const slides=Array.from(root.querySelectorAll('[data-snl-slide]'));
  const thumbs=Array.from(root.querySelectorAll('[data-snl-thumb]'));
  let index=0;
  function show(next){
    if(!slides.length)return;
    index=(next+slides.length)%slides.length;
    slides.forEach(function(slide,i){slide.hidden=i!==index});
    thumbs.forEach(function(thumb,i){thumb.classList.toggle('is-selected',i===index);thumb.setAttribute('aria-pressed',i===index?'true':'false')});
  }
  thumbs.forEach(function(thumb){thumb.addEventListener('click',function(){show(Number(thumb.getAttribute('data-snl-thumb'))||0)})});
  const prev=root.querySelector('[data-snl-prev]');
  const next=root.querySelector('[data-snl-next]');
  if(prev)prev.addEventListener('click',function(){show(index-1)});
  if(next)next.addEventListener('click',function(){show(index+1)});
  const bundles=Array.from(root.querySelectorAll('[data-snl-bundle]'));
  const total=root.querySelector('[data-snl-total]');
  const stickyPrice=root.querySelector('[data-snl-sticky-price]');
  bundles.forEach(function(bundle){
    const input=bundle.querySelector('input[type=radio]');
    if(!input)return;
    input.addEventListener('change',function(){
      bundles.forEach(function(item){item.classList.toggle('is-selected',item===bundle)});
      if(total)total.textContent=input.dataset.snlMoney;
      if(stickyPrice)stickyPrice.textContent=input.dataset.snlMoney;
    });
  });
  const scroll=root.querySelector('[data-snl-scroll]');
  if(scroll)scroll.addEventListener('click',function(){root.querySelector('.snl-offers-head').scrollIntoView({behavior:'smooth',block:'center'})});
});

  } catch(e) { console.error(e); }
})();
})();
